export function isInlineSvgIcon(icon) {
    return icon.trim().startsWith('<svg');
}
